module.exports = __webpack_public_path__ + "img/czyp.d93ee4b4.jpg";